export default __webpack_public_path__ + "static/media/CWS_Weihnachtskarte_Healthcare.2083bbe7.png";